export default __webpack_public_path__ + "static/feature-discovery-bitbucket-0d12e6744c4c4789868bf77c74b24d4d38320dd221846e4ca36b8e7bbac0051c.png";